import InputField from '../../ReusableComponents/InputField';
import SelectField from '../../ReusableComponents/SelectField';
import { AEROMEGH_SERVICES, PRICE_BY_TYPES } from '../../appConstants';
import { Button } from '../../Components/Helper';
import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import Form from '../../ReusableComponents/Form';
import Popup from '../../ReusableFunctions/Popup';
import SelectLocation from '../../features/MyLocations/SubComponents/SelectLocation';
import CustomToggle from '../../ReusableComponents/CustomToggle';
import Modal from '../../ReusableComponents/Modal';
import {
  modelNameValidation,
  phoneNumValidation,
  selectFieldValidation,
} from '../../utils/inputValidations';
import { acresToSquareKilometers } from '../../ReusableFunctions/reusableFunctions';
import CreatableSelectField from '../../ReusableComponents/CreatableSelectField';
import { v4 as uuid } from 'uuid';
import Calender from '../../assets/blueCalendar.svg';
import Loading from '../../ReusableFunctions/Loader';
import {
  createUserIfNotExists,
  getUserFromMobileNumber,
} from '../../apis/users';
import { getStates } from '../../apis/locations';
import { createLeadOrder } from '../../apis/BhuMeetTeams/CustomerSuccessEngineer/leadOrders';
import { getAllCrops } from '../../apis/crops';
import { v4 as uuidv4 } from "uuid";

const CreateOrder = ({ onClose, user, onuserCreate }) => {
    function setNext15MinuteInterval() {
        const date = new Date(); // Get the current date and time
        
    const minutes = date.getMinutes(); // Get the current minutes
    const nextInterval = Math.ceil(minutes / 15) * 15; // Calculate the next 15-min interval

    // If the next interval is 60, move to the next hour
    if (nextInterval === 60) {
      date.setHours(date.getHours() + 1); // Increment the hour
      date.setMinutes(0); // Set minutes to 0 (start of next hour)
    } else {
      date.setMinutes(nextInterval); // Set the minutes to the next interval
    }

    date.setSeconds(0); // Reset seconds to 0
    date.setMilliseconds(0); // Reset milliseconds to 0

    return date;
  }
  // Set the time to 11:00 AM
  const [request, setRequest] = useState({
    mobile_number: user?.mobile_number || '',
    name: user?.name || '',
    time: new Date(setNext15MinuteInterval()),
    field_lat: '',
    field_lng: '',
    field_name: { label: '', value: '' },
    field_address: '',
    field_area: null,
    price_by: '',
    crop_name: { label: '', value: '' },
    pesticide: { label: '', value: '' },
     state:user?.state?{label:user?.state,value:user?.state}: {label:"",value:""}
  });
  const [crops, setCrops] = useState([]);
  const [pesticides, setPesticides] = useState([{
              id:uuidv4(),
              chemical_name:"Pesticides",
            },
            {
              id:uuidv4(),
              chemical_name:"Insecticides",
            },
            {
              id:uuidv4(),
              chemical_name:"Growth Promoters",
            },
            {
              id:uuidv4(),
              chemical_name:"Fungicide",
            }]);
  const [mapLocation, setMapLocation] = useState();
  const [disableName, setDisableName] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [loading, setLoading] = useState(true);
  const [disableIfUserNotExists, setDisableIfUserNotExists] = useState(false);
  const [isFetchingUser, setIsFetchingUser] = useState(false);
  const [showCreateUser, setshowCreateUser] = useState(false);
  const [disableState, setdisableState] = useState(false);
  const [userDetails, setUserDetails] = useState(user || undefined);
  const [states, setStates] = useState([]);
  const [statesLoading, setStatesLoading] = useState(false);
  const [parametersLoading, setparametersLoading] = useState(false);
  const handleAddNewAgroChemical = (newOption) => {
    if (newOption) {
      const newAgro = {
        id: uuid(),
        chemical_name: newOption,
        subsidy: null,
      };
      setPesticides((prev) => [...prev, newAgro]);
      setRequest((prev) => ({
        ...prev,
        pesticide: { label: newAgro.chemical_name, value: newAgro.id },
      }));
    }
  };

  const getStatesFunc = async () => {
    try {
      setStatesLoading(true);
      const states = await getStates();
      setStates(states?.records);
      setStatesLoading(false);
    } catch (err) {
      setStatesLoading(false);
      console.log(err);
      Popup.alert('Error', err.errorMessage, 'ERROR');
    }
  };
  const initData = async () => {
    try {
      await getStatesFunc();
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
      Popup.alert('Something went wrong', e?.message, 'ERROR');
    }
  };

  const getUserFromMobileNumberFunc = async (mobileNo) => {
    try {
      setIsFetchingUser(true);
      setRequest((prevRequest) => ({
        ...prevRequest,
        name: '',
        state: { label: '', value: '' },
      }));
      const { user } = await getUserFromMobileNumber(mobileNo);
      if (user) {
        setDisableIfUserNotExists(false);
        setDisableName(true);
        setdisableState(true);
        setRequest((prev) => ({
          ...prev,
          name: user.user_name,
          mobile_number: mobileNo,
          state: { label: user?.state, value: user?.state },
        }));
        let updatedUser = {
          ...user,
          id: user?.user_id,
          mobile_number: user?.user_mobile,
        };
        setUserDetails(updatedUser);
      } else {
        setDisableName(false);
        setdisableState(false);
        setshowCreateUser(true);
        setDisableIfUserNotExists(true);
      }
      setIsFetchingUser(false);
    } catch (e) {
      setIsFetchingUser(false);
      setDisableName(false);
      console.log(e);
    }
  };

  const handleCreateRequest = async (updatedReq) => {
    Loading.set(true);
    setLoading(true);
    try {
      let finalReq = { ...request };
      finalReq.price_by =
        updatedReq.price_by == true ? PRICE_BY_TYPES.TANK : PRICE_BY_TYPES.ACRE;
      finalReq.field_area = updatedReq.field_area;
      finalReq.crop_name = updatedReq?.crop_name?.label;
      finalReq.time = new Date(updatedReq.time).toISOString(); //check this
      const field_area = Number(finalReq.field_area);
      finalReq.pesticide =
        pesticides.find((p) => p.id == updatedReq?.pesticide?.value)
          ?.chemical_name || '';
      finalReq.field_name = mapLocation.name;
      finalReq.field_address = mapLocation.address;
      finalReq.field_lat = mapLocation.lat;
      finalReq.field_lng = mapLocation.lng;
      finalReq.request_type = AEROMEGH_SERVICES.SPRAYING;
      finalReq.field_area =
        finalReq.price_by == PRICE_BY_TYPES.ACRE
          ? acresToSquareKilometers(field_area)
          : field_area;
      finalReq.mobile_number = updatedReq?.mobile_number;
      setRequest(updatedReq);
      await createLeadOrder(finalReq);
      Popup.alert(
        'SUCCESS',
        'Request created successfully',
        'SUCCESS',
        onClose
      );
      Loading.set(false);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      Loading.set(false);
      console.log(err);
      Popup.alert(
        'ERROR',
        err || 'Something went wrong while creating request',
        'ERROR'
      );
    }
  };


  useEffect(() => {
    initData();
  }, []);




  useEffect(() => {
    if (!user) {
      setDisableIfUserNotExists(true);
    } else {
      setUserDetails(user);
      setdisableState(true);
      setshowCreateUser(false);
    }
  }, [user]);


useEffect(() => {
    getAllCropsList()
},[])

const getAllCropsList = async () => {
    try{
       setLoading(true)
        const response = await getAllCrops();
       if (response?.crops) {
      setCrops(response.crops);
    } else {
      setCrops([]); 
    }   
        setLoading(false)
    } catch(err){
         setLoading(false)
      console.error("Failed to fetch crops:", err);
    Popup.alert(
      "Error",
      err?.message || "Something went wrong while fetching crops",
      "ERROR"
    );
    }
}


  return (
    <Modal
      header={'Create Request'}
      open={true}
      headerContainerStyle={{ padding: '10px 30px' }}
      onClose={onClose}
      closeOnDocumentClick={false}
      contentStyle={{
        height: '685px',
        width: '1200px',
        boxShadow: ' 0px 1px 4px 3px #76767626',
        border: '1px solid #BFC8D9',
        borderRadius: '8px',
        position: 'relative',
      }}
    >
      <div style={{ display: 'flex', width: '100%', height: '100%' }}>
      <div
  style={{
    width: '800px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px', 
  }}
>
  {/* Select Location (Map Component) */}
  <SelectLocation
    onLocationChange={(location) => {
      setMapLocation(location);
    //   getNearbyDsps(location);
    }}
  />

  {/* Nearby DSPs Section */}
</div>

        <Form
          onSubmitForm={(req) => {
            handleCreateRequest(req);
          }}
          initialValues={request}
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: 'calc(100% - 65px)',
            padding: '10px 30px',
            gap: '20px',
          }}
        >
          {(onSubmit, formValue) => (
            <>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  justifyContent: 'space-between',
                  width: '100%',
                  overflow: 'auto',
                }}
              >
                <div
                  id="coupen-form"
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gridAutoRows: 'auto',
                    gap: '0px 30px',
                    maxHeight: 'calc(100% - 200px)',
                  }}
                >
                  <InputField
                    label={'Mobile Number'}
                    placeholder={'Enter Mobile Number '}
                    name={'mobile_number'}
                    disabled={user?.mobile_number}
                    validation={phoneNumValidation}
                    containerStyle={{ width: '100%' }}
                    type={'text'}
                    handleChange={(value) => {
                      if (value.length === 10) {
                        getUserFromMobileNumberFunc(value);
                      } else {
                        setDisableName(false);
                      }
                      setRequest((prev) => ({ ...prev, mobile_number: value }));
                    }}
                  />
                  <InputField
                    containerStyle={{ width: '100%' }}
                    label={'Name'}
                    placeholder={'Enter Customer Name '}
                    name={'name'}
                    type={'text'}
                    disabled={disableName || user?.name}
                    handleChange={(value) => {
                      setRequest((prev) => ({ ...prev, name: value }));
                    }}
                  />

                  <SelectField
                    isLoading={statesLoading}
                    isDisabled={disableState}
                    isSearchable={true}
                    label={'State'}
                    placeholderText={'Select state'}
                    name="state"
                    styles={{
                      width: '215px',
                      height: '18px',
                      fontSize: '13px',
                    }}
                    list={states?.map((state) => ({
                      value: state.state_name_english,
                      label: state.state_name_english,
                    }))}
                    menuPortalTarget={document.getElementById('modalHolder')}
                    controlStyle={{ height: 'auto' }}
                    handleChange={(selectedstate) => {
                      console.log('running');
                      setRequest((prevRequest) => ({
                        ...prevRequest,
                        state: {
                          label: selectedstate?.label,
                          value: selectedstate?.value,
                        },
                      }));
                    }}
                    validation={selectFieldValidation}
                  />

                  
                  <div
                    style={{
                      display: 'flex',
                      width: '100%',
                      gap: '10px',
                      alignItems: 'start',
                      padding: '0px 0px 16px 0px'
                    }}
                  >
                    <div
                      className="input_field"
                      style={{ gap: '5px', width: '100%' }}
                    >
                      <label
                        htmlFor="expiryDate"
                        style={{ fontSize: '13px', color: '#3B3B3B' }}
                      >
                        {'Date'}
                      </label>
                      <div
                        className="input-date"
                        style={{
                          position: 'relative',
                          display: 'flex',
                          flexDirection: 'column',
                          rowGap: '5px',
                          justifyContent: 'center',
                          width: '100%',
                          height: '35px',
                          border: '1.4px solid rgba(217, 217, 217, 0.84)',
                        }}
                        onClick={() => {
                          if (disableIfUserNotExists) return;
                          setShowDatePicker(true);
                        }}
                      >
                        <DatePicker
                          readOnly
                          disabled={disableIfUserNotExists}
                          dateFormat="dd/MM/yyyy"
                          minDate={new Date()}
                          onClickOutside={() => setShowDatePicker(false)}
                          open={showDatePicker}
                          value={new Date(request.time)}
                          selected={new Date(request.time)}
                          className="input-date-hidden"
                          containerStyle={{ width: '100%' }}
                          onChange={(date, e) => {
                            e.stopPropagation();
                            const selectedDate = new Date(date);
                            setRequest((prev) => {
                              const updatedTime = prev.time
                                ? new Date(prev.time)
                                : new Date(); // Get current time if not selected
                              // Merge the selected date with the stored time
                              let updatedDateTime = new Date(
                                selectedDate.setHours(
                                  updatedTime.getHours(),
                                  updatedTime.getMinutes()
                                )
                              );
                              return {
                                ...prev,
                                time: new Date(updatedDateTime),
                              };
                            });
                            setShowDatePicker(false);
                          }}
                        />
                        <img
                          src={Calender}
                          alt="Calender"
                          style={{
                            width: '18px',
                            position: 'absolute',
                            right: '15px',
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <CreatableSelectField
                    isLoading={parametersLoading}
                    onCreateOption={handleAddNewAgroChemical}
                    isSearchable={true}
                    isDisabled={disableIfUserNotExists}
                    placeholder={'Select AgroChemical'}
                    label={'Agrochemical'}
                    name={'pesticide'}
                    styles={{
                      width: '215px',
                      height: '18px',
                      fontSize: '13px',
                    }}
                    list={pesticides.map((l) => ({
                      label: l.chemical_name,
                      value: l.id,
                    }))}
                    containerStyle={{
                      width: '100%',
                      maxWidth: '100%',
                      minHeight: '80px',
                    }}
                    menuPortalTarget={document.getElementById('modalHolder')}
                    controlStyle={{ height: 'auto' }}
                    handleChange={(pesticide) => {
                      setRequest((prev) => ({
                        ...prev,
                        pesticide: pesticide,
                      }));
                    }}
                    validation={modelNameValidation}
                  />

                  <SelectField
                    isLoading={loading || parametersLoading}
                    isDisabled={disableIfUserNotExists}
                    isSearchable={true}
                    label={'Crop'}
                    placeholderText={'Select Crop'}
                    name="crop_name"
                    styles={{
                      width: '215px',
                      height: '18px',
                      fontSize: '13px',
                    }}
                    list={crops.map((l) => ({
                      label: l.name,
                      value: l.id,
                    }))}
                    value={request.crop_name}
                    containerStyle={{
                      width: '100%',
                      maxWidth: '100%',
                      minHeight: '80px',
                    }}
                    menuPortalTarget={document.getElementById('modalHolder')}
                    controlStyle={{ height: 'auto' }}
                    handleChange={async (crop) => {
                        console.log('ttttttt',crop)
                      setRequest((prev) => ({
                        ...prev,
                        crop_name: crop,
                      }));
                    }}
                    validation={selectFieldValidation}
                  />

                  <div className="relative">
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        marginTop: '8px',
                        width: '200px',
                      }}
                    >
                      <CustomToggle
                        optionsStyles={{ padding: '1.5px 15px' }}
                        containerStyles={{
                          maxWidth: '150px',
                          position: 'absolute',
                          right: 0,
                          zIndex: 2,
                          cursor: 'pointer',
                        }}
                        onText={'Tank'}
                        offText={'Acre'}
                        name={'price_by'}
                        handleChange={(value) => {
                          setRequest((prev) => ({
                            ...prev,
                            price_by: value,
                            field_area: null,
                          })); //this is required real time to change inputs of acre and tank
                        }}
                        defaultValue={request.price_by}
                      />
                    </div>
                    {request.price_by ? (
                      <InputField
                        handleChange={(value) => {
                          setRequest((prev) => ({
                            ...prev,
                            field_area: value,
                          }));
                        }}
                        disabled={disableIfUserNotExists}
                        label={'No. of Tanks'}
                        placeholder={'Enter no. of tanks'}
                        name={'field_area'}
                        validation={{
                          required: 'Required',
                          maxLength: {
                            value: 3,
                            message: 'Max allowed number is 999.',
                          },
                          validate: (value) => {
                            if (isNaN(value)) {
                              return 'Must be a number.';
                            } else if (value <= 0 || value > 999) {
                              return 'No. of tanks should be between 1 to 999';
                            }
                          },
                          format: {
                            value: /^[0-9]+$/,
                            message: 'Must be a number.',
                          },
                        }}
                        type={'number'}
                      />
                    ) : (
                      <InputField
                        handleChange={(value) => {
                          setRequest((prev) => ({
                            ...prev,
                            field_area: value,
                          }));
                        }}
                        disabled={disableIfUserNotExists}
                        label={'Area (Acre)'}
                        placeholder={'Enter field area '}
                        name={'field_area'}
                        // validation={NoOfUserValidation} //add validation
                        validation={{
                          required: 'Required',
                          validate: (value) => {
                            if (value == '') {
                              return 'Required';
                            } else if (value.match(/^\d*\.?\d*$/)) {
                              const decimalValue = parseFloat(value);
                              if (
                                !isNaN(decimalValue) &&
                                (decimalValue < 0.1 || decimalValue > 1000.0)
                              ) {
                                return 'Field area in the range of 0.1 to 1000';
                              }
                            } else if (value < 0) {
                              return 'Field area in the range of 0.1 to 1000';
                            }
                          },
                        }}
                        type={'number'}
                      />
                    )}
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row-reverse',
                    padding: '10px 0px 15px',
                    gap: '20px',
                  }}
                >
                  {showCreateUser && (
                    <Button
                      text={'Save User'}
                      className={'btn-large'}
                      type={'button'}
                      isDisabled={
                        !request.mobile_number ||
                        !request?.name ||
                        request?.mobile_number?.length !== 10 ||
                        !request?.state?.value
                      }
                      onClick={async () => {
                        try {
                          let { createdUser } = await createUserIfNotExists(
                            request?.name,
                            request?.mobile_number,
                            request?.state?.value
                          );
                          setDisableIfUserNotExists(false);
                          if (onuserCreate) {
                            onuserCreate(createdUser);
                          }
                        } catch (err) {
                          Popup.alert(
                            'ERROR',
                            'something went wrong while creating user',
                            'ERROR'
                          );
                        }
                      }}
                    />
                  )}
                  <Button
                    text={'Create'}
                    className={'btn-large'}
                    type={'Save'}
                    onClick={onSubmit}
                    isDisabled={
                      !mapLocation ||
                      !request.crop_name?.label ||
                      !request.pesticide?.value ||
                      loading
                    }
                  />
                  <Button
                    text={'Cancel'}
                    type={'button'}
                    onClick={onClose}
                    isBtnNotActive={true}
                    className={'btn-large '}
                  />
                </div>
              </div>
            </>
          )}
        </Form>
      </div>
    </Modal>
  );
};
export default CreateOrder;
